import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
import { computed, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MenuBar',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const cookies = getCurrentInstance()?.appContext.config.globalProperties.$cookies;
        const safeBottom = computed(() => {
            return parseInt(cookies?.get('sb') ?? 0);
        });
        const bottomPadding = computed(() => {
            return safeBottom.value;
        });
        function handleMoneyClick() {
            clearMoneyFilter();
            if (route.path === '/money') {
                window.dispatchEvent(new CustomEvent('reset-money-filters'));
            }
            router.replace('/money');
        }
        function clearMoneyFilter() {
            localStorage.removeItem('money-filter-section');
            localStorage.removeItem('money-filter-subsection');
        }
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createBlock(_component_v_row, {
                class: "menuBar",
                style: _normalizeStyle('height:' + (78 + bottomPadding.value) + 'px; padding-bottom: ' + bottomPadding.value + 'px')
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, { class: "" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", { onClick: handleMoneyClick }, [
                                _createElementVNode("img", {
                                    src: require('@/assets/menu/Money' + (_unref(route).meta.menuItem == 'money' ? 'On' : '') + '.svg')
                                }, null, 8, _hoisted_1)
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_col, { class: "" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", {
                                onClick: _cache[0] || (_cache[0] = ($event) => { clearMoneyFilter(); _unref(router).replace('/guides'); })
                            }, [
                                _createElementVNode("img", {
                                    src: require('@/assets/menu/Guide' + (_unref(route).meta.menuItem == 'guide' ? 'On' : '') + '.svg')
                                }, null, 8, _hoisted_2)
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_col, { class: "" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", {
                                onClick: _cache[1] || (_cache[1] = ($event) => { clearMoneyFilter(); _unref(router).replace('/'); })
                            }, [
                                _createElementVNode("img", {
                                    src: require('@/assets/menu/Home' + (_unref(route).meta.menuItem == 'home' ? 'On' : '') + '.svg')
                                }, null, 8, _hoisted_3)
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_col, { class: "" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", {
                                onClick: _cache[2] || (_cache[2] = ($event) => { clearMoneyFilter(); _unref(router).replace('/activity'); })
                            }, [
                                _createElementVNode("img", {
                                    src: require('@//assets/menu/Activity' + (_unref(route).meta.menuItem == 'activity' ? 'On' : '') + '.svg')
                                }, null, 8, _hoisted_4)
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_col, { class: "" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", {
                                onClick: _cache[3] || (_cache[3] = ($event) => { clearMoneyFilter(); _unref(router).replace('/you'); })
                            }, [
                                _createElementVNode("img", {
                                    src: require('@/assets/menu/You' + (_unref(route).meta.menuItem == 'you' ? 'On' : '') + '.svg')
                                }, null, 8, _hoisted_5)
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["style"]));
        };
    }
});
